import { makeStyles } from '@material-ui/core'
import shadows from '@material-ui/core/styles/shadows'

const useStyles = makeStyles((theme) => ({
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  inputsContainerWithChannelRole: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    columnGap: 11
  },
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '8px 12px',
    margin: '24px 0px 12px 0px',
    backgroundColor: theme.palette.grey[400],
    borderRadius: 12
  },
  titleWithCalendar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '80%',
    position: 'relative'
  },
  datePickerContainer: {
    position: 'absolute',
    left: 0,
    top: 24,
    zIndex: 10,
    '&>div': {
      boxShadow: shadows[3]
    }
  },
  optionsDirection: {
    direction: 'ltr'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  header: { display: 'flex', flexDirection: 'row' },
  whiteText: { color: theme.palette.background.default, fontSize: 14 },
  btn: {
    height: 40
  },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8 }
}))
export default useStyles
